// Import react components
import React, { Component } from 'react';

// Import Screens
import './App.css';

import TableCode from './screens/TableCode/TableCode';
import Login from './screens/TableCode/Login';



import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

class App extends Component {

  render() {
    return (

        <div className="App-Container">
          <Router>
            <Switch>
              <Route
                exact
                path="/"
              component={Login}
               />
            <Route
              exact
              path="/scan"
              component={TableCode}
            />
            </Switch>
          </Router>
        </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx